import { isHttpError } from '@/api/utils/http.ts'
import { DeepBoxError } from '@/models'
import DeepErrorHandlerService from '@/services/DeepErrorHandlerService.ts'
import { useApi } from '@/composables/api.ts'
import type { AdminBox } from '@deepcloud/api-deep-box'

export const useDeepBoxAdminStore = defineStore('deepBoxAdmin', () => {
  const { deepBoxAPI } = useApi()

  const adminBox = ref<AdminBox | undefined>(undefined)
  const fetchAdminBoxByIdPending = ref(false)

  async function fetchAdminBoxById(payload: { typeId: string; boxId: string }) {
    fetchAdminBoxByIdPending.value = true
    try {
      const res = await deepBoxAPI.value.adminDeepBoxesBoxes.getById(
        payload.typeId,
        payload.boxId,
      )
      adminBox.value = res?.data
      return Promise.resolve(res)
    } catch (e: unknown) {
      adminBox.value = undefined
      let statusCode: number | undefined

      if (isHttpError(e)) {
        statusCode = e.response.status
        if (statusCode === 400) {
          DeepErrorHandlerService.error(
            new DeepBoxError('error.invalid_or_missing_params'),
          )
        }
      }
      return Promise.reject(e)
    } finally {
      fetchAdminBoxByIdPending.value = false
    }
  }

  return {
    // state
    adminBox,
    fetchAdminBoxByIdPending,
    // actions
    fetchAdminBoxById,
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useDeepBoxAdminStore, import.meta.hot))
}
